import { createSelector } from '@ngrx/store';
import { userFeature } from './user.reducer';
import { USERS_PAGE_SIZE } from './user-state.constants';
import { UserViewModel } from './user-state.model';

export const {
  selectUserState,
  selectUsers,
  selectCount,
  selectPage,
  selectSearch,
  selectIsLoadingUsers,
  selectFormToken,
  selectMode,
  selectSelectedUser,
  selectCompanies,
  selectCompanyDetail,
  selectMultiBuyerEntities,
  selectProjectManagers,
  selectIsSaving,
  selectApiToken,
  selectError,
} = userFeature;

export const selectPageNumbers = createSelector(
  selectCount,
  (count): number[] =>
    Array.from(
      { length: Math.ceil(count / USERS_PAGE_SIZE) },
      (_unused, index) => index + 1,
    ),
);

export const selectIsFormOpen = createSelector(
  selectMode,
  (mode): boolean => mode !== 'idle',
);

export const selectUserViewModel = createSelector(
  selectFormToken,
  selectMode,
  selectSelectedUser,
  selectCompanies,
  selectCompanyDetail,
  selectMultiBuyerEntities,
  selectProjectManagers,
  selectIsSaving,
  selectApiToken,
  (
    formToken,
    mode,
    selectedUser,
    companies,
    companyDetail,
    multiBuyerEntities,
    projectManagers,
    isSaving,
    apiToken,
  ): UserViewModel => ({
    formToken,
    mode,
    selectedUser,
    companies,
    companyDetail,
    multiBuyerEntities,
    projectManagers,
    isSaving,
    apiToken,
  }),
);
